import { Component, OnInit, ViewChild, OnDestroy, NgZone, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, FormBuilder } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { DatePipe, Location } from '@angular/common';
import { ProductService } from 'src/app/services/product.service';
import {
  Product,

} from 'src/app/models/product';
import { Constant } from 'src/app/constant/constant';
import { CategoryService } from 'src/app/services/category.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FieldConfig } from 'src/app/shared/dynamic-form/field-interface';
import { CalsoftAuditComponent } from 'src/app/pages/audit/audit.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, takeUntil } from 'rxjs/operators';
import { ScrollbarComponent } from 'src/app/shared/scrollbar/scrollbar.component';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { AttributesetService } from 'src/app/services/attributeset.service';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/services/config.service';
import { LeadService } from 'src/app/services/lead.service';
import { OrderReceivedPopupComponent } from '../../order-received-popup/order-received-popup.component';
import { AccessSetService } from 'src/app/services/access-set.service';
import { WebsocketService } from 'src/app/services/websocket.service';
import { LoginService } from 'src/app/services/login.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
@UntilDestroy()
@Component({
  selector: 'calsoft-add-editcommon-product',
  templateUrl: './add-editcommon-product.component.html',
  styleUrls: ['./add-editcommon-product.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' },

})
export class AddEditcommonProductComponent implements OnInit, OnDestroy {
  protected _onDestroy = new Subject<void>();
  b2bPricingEnabled: any = false;
  row: any;
  leadId: any;
  visible: boolean;
  leadAdd: any;
  description: boolean;
  attributeSetIdList: Object;
  defaultValue: any;
  defalutValue: any;
  group: UntypedFormGroup;
  attributeGroup: any;
  groupName: any;
  selection: any = [];
  entityValue: any;
  activeGroup: string;
  activeType: string;
  showOnlyStarred: boolean;

  url = '';

  text: any;
  activeGroupSubscription: Subscription;
  attributeFilterControl: UntypedFormControl = new UntypedFormControl();
  public serverPath8 = environment.commonImageApi;

  clickListeners: Function[] = [];

  respondActive: boolean;


  regConfig: FieldConfig[]

  selectedIndex = 0;
  lastIndex = 3;
  operationType: string;
  title: string;
  attributeSetList: any;


  //new
  drawerOpen = true;
  drawerMode = 'side';
  drawerDisableClose = true;
  form: UntypedFormGroup;
  invalidMap = new Map<any, any>();
  ValidMap = new Map<any, any>();
  fieldValue: any[];
  series: any = [];
  validations: any = [];
  valueId: any;
  empty: string;
  list: any;
  productEntity: any;
  leadEntityVarchar: any = [];
  leadEntityInt: any = [];
  leadEntityText: any = [];
  leadEntityDecimal: any = [];
  leadEntityStatic: any = [];
  leadEntityDatetime: any = [];
  imagesToRemoved: any = [];
  mediaGallery: any = [];
  textAdd: string;
  auditData: Object;
  auditType: any;
  filteredAttributeList: any;
  filteredAttributeTypeList: any;
  options: any;
  sameLeadName: boolean;
  visibleConfig: boolean = false;

  emailValue: any;
  phoneValue: any;
  productConfigurable: boolean;
  relatedProductList: any = [];

  productSuperLinkList: any = [];
  upSellsProductList: any = [];
  crossSellsProductList: any = [];
  productLinkList: any = [];
  relatedProducts: any = [];
  upSellsProduct: any = [];
  crossSellsProduct: any = [];
  productData: any;
  updateStockByPurchaseOnly: any = false;
  variants1: any = [];
  variants2: any = [];
  variantsList: any = [];
  leadVariant: boolean = false;
  currentIndex: any;
  data: Object;
  initalSelectionList: any = [];
  bookingEnabled: boolean = false;
  productRestriction: boolean = false;
  textAccount: string;
  orginalData: any;
  emailRequired: number = 1;
  companyRequired: number = 0;
  ownerId: number;




  previousPage() {
    this.selectedIndex -= 1;
  }

  nextPage() {
    this.selectedIndex += 1;
  }
  firstFormGroup: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private ecryptService: EcryptServiceService,
    private router: Router,
    public loc: Location,
    private route: ActivatedRoute,
    private attributeService: AttributesetService,
    private productService: ProductService,
    private categoryService: CategoryService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private commonService: CommonService,
    private cd: ChangeDetectorRef,
    private screenSizeService: ScreenSizeService,
    private mediaMatcher: MediaMatcher,
    private zone: NgZone,
    private datepipe: DatePipe,
    private configService: ConfigService,
    private _formBuilder: FormBuilder,
    private leadService: LeadService,
    private accessSetService: AccessSetService,
    public websocket: WebsocketService,
    private loginService: LoginService,
  ) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
    //this.initWebsocket();
  }

  mobileQuery = this.mediaMatcher.matchMedia('(max-width: 959px)');
  drawerOpen$ = this.screenSizeService.drawerOpen$;
  public serverPath = environment.ImageAPI;
  public serverPath1 = environment.ImageAPI1;
  public serverPath2 = environment.thumnail;
  public serverPath7 = environment.commonImageApi + "catalog/product";
  public serverPath3 = environment.ImageAPI2

  public serverPath4 = environment.commonImageApiNew

  productType: any = [
    "simple", "Configurable", "Variants", "Booking", "Subscription"
  ]

  productType1: any = [
    "simple"
  ]


  createAttributeForm() {
    this.firstFormGroup = this.formBuilder.group({
      attributeSet: ['', Validators.required],
      type: [''],
    });
  }

  createAttributeValidations = {
    'attributeSet': [
      { type: 'required', message: 'Please fill out this field.' },
    ],
    'type': [
      { type: 'required', message: 'Please fill out this field.' },
    ],

  }

  private _mobileQueryListener: () => void;

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }



  ngOnInit() {
    this.getResource();
    this.textAccount = 'OK';

    if (this.router.url.includes("/duplicateLead")) {
      this.leadId = 0;

    } else {

      this.leadId = this.route.snapshot.params['leadId'];
    }

    this.createAttributeForm();
    this.attributeSetFilter();

  }


  productLimitedRestrictionValue: any;
  productLimitedRestriction: boolean = false;

  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.LEAD)
      .subscribe((data: any) => {



        if ((this.leadId == 0 && !data.create) || (this.leadId != 0 && !data.update)) {

          this.router.navigate(['/unauthorized'])
        } else {

          this.getConfigData();

          this.productLimitedRestriction = false;


          this.defalutValue = 0;

          this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
          console.debug('[AddEditcommonProduct] initial mobileQuery.matches =', this.mobileQuery.matches);
          this._mobileQueryListener = () => {
            this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
            this.cd.detectChanges();
          };
          // Register the media query change listener so the component reacts when
          // the viewport crosses the max-width: 959px breakpoint.
          try {
            // Modern browsers support addEventListener on MediaQueryList
            this.mobileQuery.addEventListener && this.mobileQuery.addEventListener('change', this._mobileQueryListener);
          } catch (e) {
            // Fallback for older browsers that only support addListener
            // (kept for robustness; removeEventListener already used in ngOnDestroy)
            try { (this.mobileQuery as any).addListener(this._mobileQueryListener); } catch (err) { }
          }
          this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            filter(() => this.mobileQuery.matches),
            untilDestroyed(this)
          ).subscribe(() => this.closeDrawer());

          this.visible = false;
          this.text = "Save";
          this.textAdd = "Create"


          if (this.router.url.includes("/duplicateproduct")) {
            this.leadAdd = true;
            this.title = 'Add Lead'
            this.firstFormGroup.value.type = "ss";
            this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];
            this.firstFormGroup.patchValue({
              attributeSet: this.route.snapshot.params['setId']
            });

            this.operationType = 'Change'
            this.getAttributeGroup();
          }

          if (this.defaultSetType == 0) {

            if (this.leadId == 0) {
              this.leadAdd = true;
              this.title = 'Add Lead'
              this.firstFormGroup.value.type = "ss";
              this.operationType = 'New'
              this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];

              this.firstFormGroup.patchValue({
                attributeSet: this.route.snapshot.params['setId']
              });

              this.getAttributeGroup();
            }
            else if (this.leadId > 0) {
              this.title = 'Edit Lead'
              this.firstFormGroup.value.type = "ss";
              this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];
              this.operationType = 'Change'
              this.firstFormGroup.patchValue({
                attributeSet: this.route.snapshot.params['setId']
              });
              this.getAttributeGroup();
            }

          } else {

            if (this.leadId == 0) {
              this.operationType = 'New'
              this.title = 'Add Lead'
              this.getAttributeSetDropDown();


            }

            else if (this.leadId > 0) {
              this.title = 'Edit Lead'
              this.firstFormGroup.value.type = "ss";
              this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];
              this.operationType = 'Change'
              this.firstFormGroup.patchValue({
                attributeSet: this.route.snapshot.params['setId']
              });
              this.getAttributeGroup();
            }

          }


        }
      })
  }




  audit() {

    let tabs = [
      { name: 'lead', sort: "", paginator: "", label: 'lead', content: null },

    ];


    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        disableClose: true,
        width: '900px',
        data: {
          values: tabs,
          id: this.leadId,
          type: 1

        }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
    else {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        disableClose: true,
        width: '900px',
        data: {
          values: tabs,
          id: this.leadId,
          type: 1

        }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {



      });
    }
  }




  back() {
    this.loc.back();
  }




  getAttributeGroup() {

    if ((this.text == 'Save' || this.textAdd == 'Create') && this.firstFormGroup.valid) {
      this.textAdd = "Processing"
      this.entityValue = {
        "typeId": this.firstFormGroup.value.type,
        "attributeSetId": this.firstFormGroup.value.attributeSet,

      }
      this.attributeService.getattributeSetId(this.firstFormGroup.value.attributeSet).subscribe(
        attributesets => {

          this.attributeSetIdList = attributesets['data']
          this.attributeGroup = attributesets['data']['eavAttributeGroup']
          this.leadAdd = true;
          this.regConfig = this.attributeSetIdList['eavAttributeGroup']

          this.groupName = this.regConfig[this.defalutValue]['attributeGroupName']
          this.form = this.createControl();


          if (this.router.url.includes("/duplicateproduct")) {
            this.getLeadById(this.route.snapshot.params['leadId']);
          }

          else if (this.leadId > 0) {
            this.getLeadById(this.leadId);
          }

          this.textAdd = "Create";
        },
        error => {
          this.textAdd = "Create";
        }
      )
    }
    else {
      this.textAdd = "Create";
      this.validateAllFormFields(this.firstFormGroup)
    }

  }




  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }


  booleanField: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]



  getAttributeSetDropDown() {
    this.attributeService.getAttributeSetDropDownList(9).subscribe(
      res => {
        this.attributeSetList = res;

        this.filteredAttributeList = this.attributeSetList;

      },
      error => {

      }
    )
  }





  //create controls
  createControl() {
    let group;
    group = this.formBuilder.group({});




    let i = 0;
    this.regConfig.forEach(element => {


      if (element.attributeGroupId != 0) {

        element['eavEntityAttribute'].forEach(field => {

          if (field.eavAttribute.attributeCode != "special_from_date" || field.eavAttribute.attributeCode != "special_to_date") {



            this.fieldValue = field;
            if (field.eavAttribute.frontendLabel != null &&
              field.eavAttribute.frontendLabel != undefined
              && field.eavAttribute.frontendInput != null) {

              if (field.eavAttribute['isVisible'] == 1) {
                field.eavAttribute['validations'] = [];
                let val = {
                  name: "required",
                  validator: Validators.required,
                  message: " Please fill out this field.",
                }

                if (field.eavAttribute.attributeCode == "Email") {

                  if (this.emailRequired == 1) {


                    field.eavAttribute.isRequired = 1
                  } else {
                    field.eavAttribute.isRequired = 0;
                  }
                }
                else if (field.eavAttribute.attributeCode == "Company") {

                  if (this.companyRequired == 1) {
                    field.eavAttribute.isRequired = 1
                  } else {
                    field.eavAttribute.isRequired = 0;
                  }
                }

                if (field.eavAttribute.isRequired == 1) {

                  if (this.invalidMap.get(i) == undefined) {
                    let val =
                      '(' + 'this.' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='INVALID'"

                    this.invalidMap.set(i, val);
                    this.ValidMap.set(i, val);
                  } else {
                    if (field.eavAttribute.attributeCode != null) {
                      let val = '||' + 'this.' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='INVALID'"

                      let inval = '&&' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='VALID'"
                      this.invalidMap.set(i, this.invalidMap.get(i) + val);
                      this.ValidMap.set(i, this.ValidMap.get(i) + inval);
                    }
                  }
                  // this.map.set(i,field.eavAttribute.frontendLabel);
                  field.eavAttribute['validations'].push(val);
                  this.validations.push(val);

                }
                if (field.eavAttribute.frontendClass == 2 || field.eavAttribute.attributeCode == "Email" || field.eavAttribute.attributeCode == "email") {
                  let emailval = {
                    name: "pattern",
                    validator: Validators.pattern(
                      "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
                    ),
                    message: "Please enter a valid email address."
                  }
                  field.eavAttribute['validations'].push(emailval);
                  this.validations.push(emailval);
                }
                else if (field.eavAttribute.frontendClass == 1 || field.eavAttribute.frontendClass == 3) {
                  let numberval = {
                    name: "pattern",
                    validator: Validators.pattern(/^-?(0|[1-9]\d*)?$/),
                    message: "Only Numbers"
                  }
                  field.eavAttribute['validations'].push(numberval);
                  this.validations.push(numberval);
                }
                else if (field.eavAttribute.frontendClass == 5) {
                  let numberval = {
                    name: "pattern",
                    validator: Validators.pattern('^[a-zA-Z \-\']+'),
                    // validator: Validators.pattern('^[a-zA-Z][\sa-zA-Z]*'),ate
                    message: "Only  Alphabets"
                  }
                  field.eavAttribute['validations'].push(numberval);
                  this.validations.push(numberval);
                }
              }
              this.series.push({
                attributeId: field.eavAttribute.attributeId,
                entityTypeId: field.eavAttribute.entityTypeId,
                attributeCode: field.eavAttribute.attributeCode,
                backendType: field.eavAttribute.backendType,
                frontendInput: field.eavAttribute.frontendInput,
              })
              const control = this.formBuilder.control(
                field.eavAttribute.value,
                this.bindValidations(field.eavAttribute.validations || [])
              );
              group.addControl(field.eavAttribute.attributeCode, control);
              //group.controls[field.eavAttribute.attributeCode].setValue(0);

              if (field.eavAttribute.backendType == 'int' && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
                group.controls[field.eavAttribute.attributeCode].setValue(parseInt(field.eavAttribute.defaultValue), { onlySelf: true });
              }
              else if ((field.eavAttribute.backendType == 'varchar' || field.eavAttribute.backendType == 'text') && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
                group.controls[field.eavAttribute.attributeCode].setValue(field.eavAttribute.defaultValue, { onlySelf: true });
              }
              // else if (field.eavAttribute.backendType == 'datetime' && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {

              //   group.controls[field.eavAttribute.attributeCode].setValue(new Date(field.eavAttribute.defaultValue), { onlySelf: true });
              // }
            }
          }
        });
        if (this.invalidMap.get(i) != undefined) {
          let finaloutputInValid = this.invalidMap.get(i) + ')';
          this.invalidMap.set(i, finaloutputInValid);
          let finaloutputValid = this.ValidMap.get(i) + ')';
          this.ValidMap.set(i, finaloutputValid);
        }
        i++;
      }
    });


    return group;
  }



  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  //edit a Categor
  getLeadById(entityId: number) {
    this.leadService.getLeadById(entityId)
      .subscribe(
        (product: Product) =>
          this.editProduct(product),



        (err: any) => { }
      );

  }

  listOfOptions: any = [];
  editProduct(product: Product) {

    this.productData = product;
    if (this.firstFormGroup && this.firstFormGroup.value) {
      this.firstFormGroup.value.typeId = product.typeId;
    }
    let products = product.values || {};
    this.phoneValue = products['PhoneNumber'];
    this.emailValue = products['Email'];
    this.orginalData = products['originalData'];
    this.valueId = product.valueIds;

    this.series.forEach(element => {
      try {
        let attributeCode = element.attributeCode;
        if (!attributeCode) return;

        let rawVal = products[attributeCode];
        if (rawVal === undefined && attributeCode) {
          rawVal = products[attributeCode.toLowerCase()] !== undefined ? products[attributeCode.toLowerCase()] : null;
        }

        const isMulti = element.frontendInput == 'multiselect' ||
                        element.frontendInput == 'multi-select' ||
                        attributeCode == 'TagName' ||
                        attributeCode == 'Tags' ||
                        attributeCode == 'tag_name';

        if (isMulti) {
          let listOfOptions: any[] = [];
          if (rawVal != null && rawVal !== '') {
            if (Array.isArray(rawVal)) {
              listOfOptions = rawVal;
            } else {
              (rawVal + '').split(',').forEach(item => {
                const trimmed = item.trim();
                const parsed = parseInt(trimmed, 10);
                listOfOptions.push(!isNaN(parsed) && (parsed + '') === trimmed ? parsed : trimmed);
              });
            }
          }
          this.form.patchValue({
            [attributeCode]: listOfOptions
          });
        }
        else if (element.backendType == 'datetime') {
          if (rawVal != null && rawVal !== '') {
            let str = (rawVal + '').trim();
            if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
              str += 'T00:00:00';
            } else if (/^\d{4}-\d{2}-\d{2}[ T]05:30:00(\.000)?$/.test(str)) {
              str = str.substring(0, 10) + 'T00:00:00';
            } else if (str.includes(' ') && !str.includes('T')) {
              str = str.replace(' ', 'T');
            }
            const d = new Date(str);
            this.form.patchValue({
              [attributeCode]: !isNaN(d.getTime()) ? d : rawVal,
            });
          }
        }
        else {
          this.form.patchValue({
            [attributeCode]: rawVal !== undefined ? rawVal : null
          });
        }
      } catch (err) {
        console.error('Error patching field attributeCode:', element?.attributeCode, err);
      }
    });

    const propName = products['PropertyName'] || products['propertyName'] || products['Property'] || products['property'];
    const propId = products['PropertyId'] || products['propertyId'] || products['PrimaryPlan'] || products['primaryPlan'];

    if (propName && this.form) {
      ['PropertyName', 'propertyName', 'Property', 'property'].forEach(k => {
        if (this.form.get(k)) this.form.get(k).setValue(propName, { emitEvent: false });
      });
    }
    if (propId && this.form) {
      ['PropertyId', 'propertyId', 'PrimaryPlan', 'primaryPlan'].forEach(k => {
        if (this.form.get(k)) this.form.get(k).setValue(propId, { emitEvent: false });
      });
    }

  }
  public toggleMenuItem(menuId) {
    let menuItem = document.getElementById('menu-item-' + menuId);
    let subMenu = document.getElementById('sub-menu-' + menuId);
    if (subMenu) {
      if (subMenu.classList.contains('show')) {
        subMenu.classList.remove('show');
        menuItem.classList.remove('expanded');
      }
      else {
        subMenu.classList.add('show');
        menuItem.classList.add('expanded');
      }
    }
  }




  saveLead() {



    if (this.sameLeadName) {

      this.ownerId = 0;

      let leadEntity = {
        leadVarchar: [],
        leadInt: [],
        leadText: [],
        leadDecimal: [],
        leadDateTime: [],

      }

      for (let i = 0; i < this.series.length; i++) {


        if (this.series[i].attributeCode == "OwnerId") {

          this.ownerId = this.form.value[this.series[i].attributeCode];
        }

        this.series[i].value = this.form.value[this.series[i].attributeCode];
        if (this.leadId > 0) {
          this.series[i].entityId = this.leadId;
          this.series[i].valueId = parseInt(this.valueId[this.series[i].attributeCode]);
        }
        this.series[i].storeId = 1;
        if (this.series[i].backendType == "varchar" && this.series[i].value != null && this.series[i]) {
          this.series[i].entityId = this.leadId;
          if (Array.isArray(this.series[i].value)) {
            this.series[i].value = this.series[i].value.join(',');
          } else {
            this.series[i].value = String(this.series[i].value);
          }
          leadEntity.leadVarchar.push(this.series[i]);
        } else if (this.series[i].backendType == "int") {
          this.series[i].entityId = this.leadId;
          let val = this.series[i].value;
          if (Array.isArray(val)) {
            let firstVal = val.length > 0 ? val[0] : null;
            let numVal = parseInt(firstVal, 10);
            this.series[i].value = !isNaN(numVal) ? numVal : null;
          } else if (typeof val === 'string' && val.includes(',')) {
            let firstVal = val.split(',')[0].trim();
            let numVal = parseInt(firstVal, 10);
            this.series[i].value = !isNaN(numVal) ? numVal : null;
          }
          leadEntity.leadInt.push(this.series[i]);
        }
        else if (this.series[i].backendType == "text") {
          this.series[i].entityId = this.leadId;
          leadEntity.leadText.push(this.series[i])
        } else if (this.series[i].backendType == "decimal") {

          if (this.series[i].value == null) {
            this.series[i].entityId = this.leadId;
            this.series[i].value = 0.0;
            this.series[i].value = parseFloat(this.series[i].value)
          }
          leadEntity.leadDecimal.push(this.series[i])
        }
        else if (this.series[i].backendType == "datetime") {
          if (this.series[i].value != null && this.series[i].value !== '') {
            this.series[i].entityId = this.leadId;
            let val = this.series[i].value;
            let d: Date = null;
            if (val instanceof Date) {
              d = new Date(val.getTime());
            } else if (typeof val === 'string') {
              let str = val.trim();
              if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
                str += 'T00:00:00';
              } else if (/^\d{4}-\d{2}-\d{2}[ T]05:30:00(\.000)?$/.test(str)) {
                str = str.substring(0, 10) + 'T00:00:00';
              } else if (str.includes(' ') && !str.includes('T')) {
                str = str.replace(' ', 'T');
              }
              d = new Date(str);
            } else {
              d = new Date(val);
            }
            if (d && !isNaN(d.getTime())) {
              if (d.getHours() === 5 && d.getMinutes() === 30 && d.getSeconds() === 0) {
                d.setHours(0, 0, 0, 0);
              }
              const formattedDate = this.datepipe.transform(d, "yyyy-MM-dd'T'HH:mm:ss");
              this.series[i].value = formattedDate;
            }
            leadEntity.leadDateTime.push(this.series[i]);
          }
        }

      }

      leadEntity['operationType'] = this.leadId == 0 ? "NEW" : "CHANGE";
      leadEntity['entityTypeId'] = 9;
      leadEntity['attributeSetId'] = this.entityValue.attributeSetId;
      leadEntity['typeId'] = this.leadId == 0 ? this.entityValue.typeId : this.firstFormGroup.value.typeId;
      leadEntity['hasOptions'] = 4;

      leadEntity['leadSourceId'] = this.form.value.LeadSource;

      leadEntity['leadStatusId'] = this.form.value.LeadStatus;
      leadEntity['city'] = this.form.value.City;
      leadEntity['state'] = this.form.value.State;
      leadEntity['type'] = this.form.value.Type;
      leadEntity['country'] = this.form.value.Country;
      leadEntity['formId'] = this.form.value.FormId;
      leadEntity['distributorId'] = this.form.value.Distributor;


      leadEntity['telephone'] = this.form.value.PhoneNumber;

      leadEntity['email'] = this.form.value.Email;

      if (this.orginalData != undefined) {
        if (this.orginalData != null) {
          leadEntity['originalData'] = this.orginalData;
        }
      }

      if (this.leadId > 0) {
        leadEntity['entityId'] = this.leadId;


      }
      if (this.ownerId > 0) {
        leadEntity['ownerId'] = this.ownerId;
      }

      this.leadService.addlead(leadEntity).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.clearValue();
            this.router.navigate(['lead']);

            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.text = "Save"

          }

          else {
            this.text = "Save"
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }

        },
        (err) => { this.text = "Save" });
    } else {
      this.text = "Save"
      this.validateAllFormFields(this.form);
    }
  }

  clearValue() {

    let url = "/lead";
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");

  }
  checkLeadExist() {

    if ((this.emailValue != this.form.value.Email
      || this.phoneValue != this.form.value.PhoneNumber)) {
      let payload = {
        "Email": this.form.value.Email,
        "PhoneNumber": this.form.value.PhoneNumber,
        "entityId": this.leadId
      }

      console.log("payload", payload);

      this.leadService.leadAlreadyExist(payload).subscribe(
        (response) => {

          if (response == null || response == undefined) {
            this.sameLeadName = true;
            return;
          }

          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.sameLeadName = true;
            this.saveLead();
          }
          else {
            this.text = "Save"
            this.snackBar.open(response['data']['message'], '×',
              { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => {
          this.text = "Save"
          this.sameLeadName = true
        });

      return this.sameLeadName;
    } else {

      this.saveLead()
    }

  }




  check() {
    if (this.leadId != 0) {
      this.firstFormGroup.value.operationType = "Change"
    }
    else {
      this.firstFormGroup.value.operationType = "New"
    }
    if (this.form.valid) {

      if (this.leadId == 0) {
        this.checkLeadExist();
        this.sameLeadName = false;
      }
      // this.phoneValue = product['values']['PhoneNumber'];
      // this.emailValue = product['values']['Email'];
      else if (this.leadId > 0 && (this.emailValue != this.form.value.Email
        || this.phoneValue != this.form.value.PhoneNumber)) {
        this.checkLeadExist();
        this.sameLeadName = false;
      }
      else {
        this.sameLeadName = true;
        this.saveLead();
      }

    }


  }
  save() {

    this.text = "Processing"
    if (this.leadId != 0) {
      this.firstFormGroup.value.operationType = "Change"
    }
    else {
      this.firstFormGroup.value.operationType = "New"
    }
    if (this.form.valid) {
      this.sameLeadName = true
      this.check()

    } else {
      this.text = "Save"
      this.validateAllFormFields(this.form);
    }
  }



  checkValidataion(i) {

    return eval(this.invalidMap.get(i));

  }

  drawerChange(drawerOpen: boolean) {
    this.screenSizeService.drawerOpen.next(drawerOpen);
  }

  openDrawer() {
    console.debug('[AddEditcommonProduct] openDrawer called');
    this.screenSizeService.drawerOpen.next(true);
    this.cd.markForCheck();
  }

  closeDrawer() {
    console.debug('[AddEditcommonProduct] closeDrawer called');
    this.screenSizeService.drawerOpen.next(false);
    this.cd.markForCheck();
  }

  @ViewChild(ScrollbarComponent, { static: true }) scrollbar: ScrollbarComponent;
  public tabsContentRef!: ScrollbarComponent;
  scrollToBottom() {
    this.tabsContentRef.scrollbarRef.getScrollElement().scrollTo({
      behavior: 'smooth',
      top: 0
    });

  }

  onActivate() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  duplicate() {

    this.router.navigate([`product/duplicateproduct/${this.leadId}/${this.route.snapshot.params['setId']}`])
  }


  attributeSetFilter() {
    this.attributeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.attributeFilter();
      });
  }


  protected attributeFilter() {
    if (!this.attributeSetList) {
      return;
    }
    // get the search keyword
    let search = this.attributeFilterControl.value;
    if (!search) {
      this.filteredAttributeList = this.attributeSetList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredAttributeList = this.attributeSetList.filter(attributeSetName => attributeSetName['attributeSetName'].toLowerCase().indexOf(search) > -1)
  }

  _keyPress(event: any) {
    const pattern = /[^0-9.]*/;
    let inputChar = String.fromCharCode(event.charCode).trim();

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    } else if (inputChar.length == 0) {
      event.preventDefault();
    }

  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.openDrawer()
  }

  defaultSetType: any = 0;

  getConfigData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        localStorage.setItem("value", JSON.stringify(data))
        this.data = data;

        this.defaultSetType = data['defaultSetType'];

        this.emailRequired = data['leadEmail'] || 0;
        this.companyRequired = data['companiesEmail'] || 0;

      }

      catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }


  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Backspace') {
      event.preventDefault();
    }
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;


  }

  get(i, j, k) {

    this.defalutValue = '';
    this.groupName = i;
    this.defalutValue = j;


    this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
    //this.scrollToBottom();
  }

  orderConfirmPopup() {
    let dialogRef = this.dialog.open(OrderReceivedPopupComponent, {
      width: '250px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
    const audio = new Audio();
    audio.src = 'assets/order-voice/lead.mp3';
    audio.load();
    audio.play();
  }





  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
